import { StyleSheet, Text, View } from 'react-native';
import React, { FC, useCallback } from 'react';
import { BookingType } from '../types';
import { useSelector } from 'react-redux';
import { RootState } from '../../../services/redux/store';
import { STYLE_VARS } from '../../../constants/style-vars';
import dayjs from 'dayjs';
import { Button } from '../../../components/Button';
import { FONTS } from '../../../constants';
import { IBookedSport } from '../../../types/sports.types';
import { convertToAmPm, convertToUTCHours } from '../../../services/utils';
import { IBookedEvent } from '../../../types';
import { IBookedDining } from '../../../types/dining.types';
import { convertUnixToUTCDate } from '../../../services/utils/dateConvert';

interface BookingDiningProps {
  booking: IBookedDining;
  onCancelBooking?: (bookingId: number) => void;
  bookingType?: string;
  isPast?: boolean;
}

const BookingDining: FC<BookingDiningProps> = ({
  booking,
  onCancelBooking,
  bookingType,
  isPast = false,
}) => {
  const { user } = useSelector((redux: RootState) => ({
    user: redux.user.data,
  }));

  return (
    <View style={styles.wrapper}>
      <View
        style={{
          flexDirection: 'row',
          justifyContent: 'space-between',
          alignItems: 'flex-start',
        }}
      >
        <Text style={styles.name} numberOfLines={3}>
          {booking.venue || ''}
        </Text>
        <Text
          style={[
            styles.textStyle,
            {
              width: '35%',
              textAlign: 'right',
            },
          ]}
        >
          {convertToAmPm(convertToUTCHours(booking.date))}
        </Text>
      </View>
      <View
        style={{
          flexDirection: 'row',
          justifyContent: 'space-between',
          alignItems: 'flex-end',
        }}
      >
        <View style={{ width: '65%' }}>
          <Text style={styles.textStyle}>
            {convertUnixToUTCDate(booking.date).format('DD MMMM YYYY')}
          </Text>
          <Text style={styles.textStyle}>Type: {bookingType}</Text>
          <Text style={styles.textStyle}>Status: {booking.status}</Text>
        </View>
        <View>
          {booking.status === 'Pending' && !isPast && (
            <Button
              text="CANCEL"
              style={STYLE_VARS.dangerButton}
              className=""
              onPress={() => {
                if (onCancelBooking) onCancelBooking(booking.id);
              }}
            />
          )}
        </View>
      </View>
    </View>
  );
};

export default BookingDining;

const styles = StyleSheet.create({
  wrapper: {
    paddingVertical: 20,
    borderBottomColor: STYLE_VARS.fccDarkGrey,
    borderBottomWidth: 1,
  },
  name: {
    width: '65%',
    fontSize: 16,
    letterSpacing: 1,
    fontFamily: FONTS.IowanOldStyleBTRoman,
    color: STYLE_VARS.textColor,
    textTransform: 'uppercase',
  },
  textStyle: {
    fontSize: 13,
    lineHeight: 20,
    letterSpacing: 1,
    fontFamily: FONTS.IowanOldStyleBTRoman,
    color: STYLE_VARS.fccDarkerGrey,
    textTransform: 'uppercase',
  },
});
